import * as React from 'react';

import { Button, Menu, MenuItem } from './styles';

type DropDownButtonProps = {
  title: string;
  disabled: boolean;
  buttons: {
    label: string;
    handler: () => void;
  }[];
};

const DropDownButton: React.FC<DropDownButtonProps> = ({
  title,
  disabled,
  buttons,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event: React.MouseEvent<HTMLLIElement>) => {
    setAnchorEl(null);

    // @ts-ignore
    const index = +event.target.dataset.id;
    if (Number.isNaN(index)) return;

    buttons[index].handler();
  };

  return (
    <div>
      <Button
        id="basic-button"
        color="secondary"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disabled={disabled}
        onClick={handleClick}
      >
        {title}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {buttons.map((button, index) => (
          <MenuItem key={button.label} data-id={index} onClick={handleClose}>
            {button.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default DropDownButton;
